/**
 * Page produit flagship — FOG Theme (clone Webflow)
 * Interactions : variantes via .button-option, barres de performance
 * pilotees par metafields variant, video + specs dynamiques par variante,
 * add-to-cart AJAX, quantite +/-.
 *
 * Cible les classes Webflow originales.
 */
(function () {
  'use strict';

  /* Libelles : snippets/i18n-js.liquid (window.FOG_I18N, charge avant ce script
     par layout/theme.liquid). Lu a l'appel, jamais en dur. Spec 07. */
  function i18n(cle, vars) {
    return window.FOG_I18N.t(cle, vars);
  }

  var page = document.querySelector('[data-section-type="product-configurable"]');
  if (!page) return;

  // === DATA ===
  var variantsJSON = document.getElementById('product-variants-json');
  var configJSON = document.getElementById('product-config-data');
  var variants = variantsJSON ? JSON.parse(variantsJSON.textContent) : [];
  var config = configJSON ? JSON.parse(configJSON.textContent) : {};

  // === STATE ===
  var state = {
    selectedOptions: {},
    currentVariant: null
  };

  // === B2B (SparkLayer) ===
  // La zone #product-b2b n'est rendue par Liquid QUE pour un compte b2b
  // (masquage serveur du prix retail). Sa presence = mode B2B.
  var b2bZone = document.getElementById('product-b2b');
  var isB2b = !!b2bZone;
  if (isB2b && window.console) console.log('[FOG B2B] init v2 (window.spark)');
  var B2B = isB2b ? {
    productId: b2bZone.getAttribute('data-product-id'),
    currency: b2bZone.getAttribute('data-currency') || 'CHF',
    // Devise de presentation du prix public (Shopify Markets), pour ne comparer
    // que des montants comparables.
    retailCurrency: (b2bZone.getAttribute('data-retail-currency') || '').toUpperCase(),
    // Facteur de taxe du prix public : 1.081 sur un marche a prix TTC (Suisse),
    // 1 quand le prix Shopify est deja HT, 0 si le taux n'est pas renseigne
    // (comparatif public masque plutot qu'un montant faux). Cf. le reglage de
    // theme « Tarifs B2B » dans snippets/product-configurable-inline.liquid.
    retailTaxFactor: parseFloat(b2bZone.getAttribute('data-retail-tax-factor')) || 0,
    // Derniere devise renvoyee par SparkLayer, pour reformater le prix public
    // pendant un recalcul sans attendre la reponse.
    lastCurrency: null
  } : null;

  // Capture l'instance Spark via onready (si l'init n'a pas encore eu lieu)
  // sans ecraser un handler existant ; sinon on retombe sur window.SparkLayer.
  var _spark = null;
  if (isB2b) {
    window.sparkOptions = window.sparkOptions || {};
    // Recalcule le prix pro des que le SDK signale un etat pret (init tardive) :
    // onready (SDK pret) ET oncartload (donnees B2B/prix chargees) -> affichage
    // au plus tot, sans attendre un tick du polling de secours. On chaine les
    // handlers existants de l'app embed pour ne pas les ecraser.
    var _fireB2b = function () { try { if (state.currentVariant) updateB2bPrice(state.currentVariant); } catch (e) {} };
    var _prevOnReady = window.sparkOptions.onready;
    window.sparkOptions.onready = function (s) {
      _spark = s;
      if (typeof _prevOnReady === 'function') { try { _prevOnReady(s); } catch (e) {} }
      _fireB2b();
    };
    var _prevOnCartLoad = window.sparkOptions.oncartload;
    window.sparkOptions.oncartload = function (c) {
      if (typeof _prevOnCartLoad === 'function') { try { _prevOnCartLoad(c); } catch (e) {} }
      _fireB2b();
    };
  }

  function getSpark() {
    // SparkLayer expose son SDK sous window.spark (constate sur futureofgrow).
    if (window.spark && typeof window.spark.calculatePricingForVariant === 'function') return window.spark;
    if (_spark && typeof _spark.calculatePricingForVariant === 'function') return _spark;
    if (window.SparkLayer && typeof window.SparkLayer.calculatePricingForVariant === 'function') return window.SparkLayer;
    return null;
  }

  function whenSparkReady(cb) {
    var s = getSpark();
    if (s) { cb(s); return; }
    var tries = 0;
    var iv = setInterval(function () {
      tries++;
      var s2 = getSpark();
      if (s2) { clearInterval(iv); cb(s2); }
      else if (tries >= 60) { clearInterval(iv); cb(null); } // ~30 s avant repli
    }, 500);
  }

  function b2bQty() {
    var q = document.getElementById('product-quantity');
    var n = q ? parseInt(q.value, 10) : 1;
    return (isNaN(n) || n < 1) ? 1 : n;
  }

  /* Montant en unite majeure (le SDK SparkLayer renvoie 437.7, pas 43770).
     Ecrit par window.FOG_MONEY, donc dans la meme forme que tous les prix du
     site (« CHF 437.70 ») : Intl ecrivait « 437.70 CHF » juste a cote d'un
     prix public Liquid « CHF 832.50 ». Cf. assets/money-format.js. */
  function formatB2bMoney(amount, currency) {
    var cents = Math.round(Number(amount) * 100);
    if (window.FOG_MONEY) return window.FOG_MONEY.format(cents, currency);
    return (cents / 100).toFixed(2) + ' ' + currency;
  }

  // Prix public du variant courant, en unite majeure et HORS TAXES (le JSON Liquid
  // est en centimes, dans la presentation du marche. Depuis le 17 aout 2026 aucun
  // marche FOG n'est en prix taxe incluse : le facteur vaut 1, la division est neutre.
  function retailAmount(variant) {
    var cents = variant ? variant.price : null;
    if (typeof cents !== 'number' || !(cents > 0)) return null;
    if (!(B2B.retailTaxFactor > 0)) return null; // taux de taxe inconnu
    return (cents / 100) / B2B.retailTaxFactor;
  }

  // Pendant un recalcul, le prix public suit immediatement la configuration choisie :
  // il est connu cote client, contrairement au tarif pro.
  function refreshRetailAmount(variant) {
    var el = b2bZone.querySelector('[data-b2b-retail-amount]');
    var retail = retailAmount(variant);
    if (el && retail) el.textContent = formatB2bMoney(retail, B2B.lastCurrency || B2B.currency);
  }

  // Comparatif « Prix public CHF 1,099.00 HT » barre + badge « −34 % » accroche a
  // « Votre prix » (decision du 24 septembre 2026), meme lecture que la carte
  // collection. Remise HT contre HT : retailAmount() rend le public hors taxes, le
  // SDK rend le tarif pro hors taxes. Deux garde-fous : meme devise des deux cotes
  // (en presentation multi-devise, comparer un public CHF a un tarif pro EUR
  // donnerait une economie fausse) et economie reellement positive (sinon on ne
  // barre rien).
  function renderB2bSavings(variant, unitPrice, currency) {
    var retail = retailAmount(variant);
    var sameCurrency = !B2B.retailCurrency || B2B.retailCurrency === currency;
    if (!sameCurrency && window.console) {
      console.warn('[FOG B2B] comparatif public masque, devises differentes :', B2B.retailCurrency, 'vs', currency);
    }
    if (!retail || !sameCurrency || !(unitPrice < retail)) {
      b2bZone.removeAttribute('data-savings');
      return;
    }
    var pct = Math.round(((retail - unitPrice) / retail) * 100);
    if (pct < 1) { b2bZone.removeAttribute('data-savings'); return; }
    var amountEl = b2bZone.querySelector('[data-b2b-retail-amount]');
    var discountEl = b2bZone.querySelector('[data-b2b-discount]');
    if (amountEl) amountEl.textContent = formatB2bMoney(retail, currency);
    /* « −40 % » : signe moins typographique, espace insecable avant %. */
    if (discountEl) discountEl.textContent = i18n('products.b2b.discount_badge', { percent: pct });
    b2bZone.setAttribute('data-savings', 'true');
  }

  function updateB2bPrice(variant, attempt) {
    if (!isB2b || !b2bZone || !variant || !variant.sku) return;
    attempt = attempt || 0;
    var reqSku = variant.sku;
    var qty = b2bQty();
    if (attempt === 0) {
      if (b2bZone.getAttribute('data-state') === 'priced') {
        // Un tarif est deja affiche : on l'estompe le temps du recalcul plutot que
        // de repasser par le skeleton a chaque clic d'option ou de quantite.
        b2bZone.setAttribute('data-pending', 'true');
        refreshRetailAmount(variant);
      } else {
        b2bZone.setAttribute('data-state', 'loading');
      }
    }

    // Au chargement, window.spark existe souvent AVANT que les prix B2B soient
    // charges (auth + price list SparkLayer en cours) : l'appel renvoie alors un
    // prix vide. On re-tente quelques fois avant de replier sur "Tarif sur demande".
    function retryOrQuote() {
      if (attempt < 40 && state.currentVariant && state.currentVariant.sku === reqSku) {
        // Au-dela de ~1 s, le tarif encore affiche n'est plus credible pour la
        // nouvelle configuration : retour au skeleton.
        if (attempt >= 8 && b2bZone.getAttribute('data-pending') === 'true') {
          b2bZone.removeAttribute('data-pending');
          b2bZone.removeAttribute('data-savings');
          b2bZone.setAttribute('data-state', 'loading');
        }
        // Essais rapproches au debut (capter des que le SDK a charge les prix),
        // puis on espace pour ne pas boucler inutilement.
        setTimeout(function () { updateB2bPrice(variant, attempt + 1); }, attempt < 8 ? 100 : 300);
      } else {
        if (window.console) console.warn('[FOG B2B] repli "Tarif sur demande" pour', reqSku);
        b2bZone.removeAttribute('data-pending');
        b2bZone.removeAttribute('data-savings');
        b2bZone.setAttribute('data-state', 'quote');
      }
    }

    whenSparkReady(function (spark) {
      if (!spark) { retryOrQuote(); return; }
      Promise.resolve(spark.calculatePricingForVariant(B2B.productId, reqSku, qty, null))
        .then(function (res) {
          // Ignore une reponse obsolete (variant change entre-temps).
          if (!state.currentVariant || state.currentVariant.sku !== reqSku) return;
          // Le SDK renvoie le prix unitaire en unite majeure (ex. 437.7) + la devise.
          var unit = null;
          if (res) {
            if (res.unitPrice != null) unit = res.unitPrice;
            else if (res.priceBreaks && res.priceBreaks[0] && res.priceBreaks[0].price) unit = res.priceBreaks[0].price.net;
          }
          if (unit == null || isNaN(unit)) { retryOrQuote(); return; }
          var cur = (res && res.currencyCode) ? String(res.currencyCode).toUpperCase() : B2B.currency;
          B2B.lastCurrency = cur;
          var amtEl = b2bZone.querySelector('[data-b2b-amount]');
          /* Pas de « HT » concatene ici : la mention est rendue en Liquid a cote
             du montant (.pc-b2b__tax), et les deux s'affichaient ensemble. */
          if (amtEl) amtEl.textContent = formatB2bMoney(unit, cur);

          /* Second montant TTC (Suisse), a partir du tarif pro obtenu du SDK, donc
             du montant exact affiche au-dessus. Indicatif : le panier et le tunnel
             de commande SparkLayer restent en HT. Cf. assets/price-ttc.js.

             Meme garde-fou de devise que renderB2bSavings() juste en dessous, et
             que les cartes et la fiche simple : au premier chargement qui suit un
             changement de compte, SparkLayer sert encore la price list precedente
             (mesure du 13 septembre 2026). Pas de TVA suisse sur un montant qui
             n'est pas dans la devise du marche ; apply() retire alors le montant. */
          if (window.FOG_TTC && amtEl) {
            var ttcSameCurrency = !B2B.retailCurrency || B2B.retailCurrency === cur;
            window.FOG_TTC.apply(amtEl.parentNode, ttcSameCurrency ? Math.round(unit * 100) : null, cur);
          }

          renderB2bSavings(variant, unit, cur);
          b2bZone.removeAttribute('data-pending');
          b2bZone.setAttribute('data-state', 'priced');
          if (window.console) console.log('[FOG B2B] priced', reqSku, amtEl && amtEl.textContent);
        })
        .catch(function (e) {
          if (window.console) console.warn('[FOG B2B] pricing error', e);
          retryOrQuote();
        });
    });
  }

  function addToCartB2b(variant, qty) {
    if (!variant || !variant.sku) return;
    var btn = document.getElementById('add-to-cart-btn');
    var text = document.getElementById('atc-text');
    var spinner = document.getElementById('atc-spinner');
    if (btn) btn.classList.add('loading');
    if (text) text.style.display = 'none';
    if (spinner) spinner.style.display = 'inline-block';
    whenSparkReady(function (spark) {
      if (!spark || typeof spark.updateCart !== 'function') { resetButton(); return; }
      // Forme lue par la mutation SparkLayer (CartItemInput, introspection du
      // 2026-10-04) : sku + deltaQuantity, customAttributes obligatoire.
      // L'ancienne forme { items: [{ parentProductId, variantSku, qty }] } etait
      // ignoree sans erreur : reponse [] et rien n'arrivait au panier.
      Promise.resolve(spark.updateCart({ products: [{ sku: variant.sku, deltaQuantity: qty, customAttributes: [] }] }, false, false))
        .then(function (results) {
          var added = Array.isArray(results) && results.some(function (r) { return r && r.resultantQuantity > 0; });
          if (!added) throw new Error('SparkLayer n\'a rien ajoute : ' + JSON.stringify(results));
          if (btn) { btn.classList.remove('loading'); btn.classList.add('is-success'); }
          if (spinner) spinner.style.display = 'none';
          if (text) { text.style.display = ''; text.textContent = i18n('products.configurable.added_short'); }
          setTimeout(resetButton, 1600);
        })
        .catch(function (e) {
          if (window.console) console.warn('[FOG B2B] cart error', e);
          if (btn) { btn.classList.remove('loading'); btn.classList.add('is-error'); }
          if (spinner) spinner.style.display = 'none';
          if (text) { text.style.display = ''; text.textContent = i18n('products.configurable.error_short'); }
          setTimeout(resetButton, 1600);
        });
    });
  }

  // === HELPERS ===
  /* Le symbole etait code en dur en euro : sur le marche suisse, changer d'option
     transformait un prix rendu « CHF 832.50 » par Liquid en « 832,50 € ».
     Le montant est desormais ecrit par window.FOG_MONEY dans la devise et la
     forme du marche courant : il garde la meme forme avant et apres un
     changement d'option, et la meme que partout ailleurs sur le site. */
  function formatMoney(cents) {
    return formatB2bMoney(cents / 100, config.currency || 'CHF');
  }

  /* Ecrit un montant sans effacer la mention « HT » ou « TTC » posee par
     price-pair : un textContent direct la supprimerait au premier changement
     d'option, et le montant suisse ne serait plus qualifie. */
  function setAmountText(el, text) {
    if (!el) return;
    var tax = el.querySelector('.tax-mention');
    /* L'espace insecable qui precede la mention est un noeud de texte, efface
       comme le reste par textContent : il est repose avec elle, sinon le montant
       se lit « CHF 832.50HT » des le premier changement d'option. */
    el.textContent = text;
    if (tax) {
      el.appendChild(document.createTextNode('\u00A0'));
      el.appendChild(tax);
    }
  }

  function findVariant() {
    // Read active button-option values
    var optionGroups = page.querySelectorAll('.option_group');
    var selected = {};
    optionGroups.forEach(function (group) {
      var idx = parseInt(group.getAttribute('data-option-index'), 10);
      var activeBtn = group.querySelector('.button-option.active');
      if (activeBtn) {
        selected['option' + (idx + 1)] = activeBtn.getAttribute('data-option-value');
      }
    });
    state.selectedOptions = selected;

    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      var match = true;
      for (var key in selected) {
        if (selected.hasOwnProperty(key) && v[key] !== selected[key]) {
          match = false;
          break;
        }
      }
      if (match) return v;
    }
    return null;
  }

  function updatePrice(variant) {
    var priceEl = document.getElementById('product-price');
    var compareEl = document.getElementById('product-compare-price');
    if (!priceEl) return;

    if (variant) {
      /* Particulier livre en Suisse : le montant affiche est le TTC, prix barre
         compris, comme le rendu Liquid initial (snippets/price-pair.liquid).
         Ailleurs displayCents() rend le HT inchange. Cf. assets/price-ttc.js. */
      var shown = window.FOG_TTC ? window.FOG_TTC.displayCents : function (c) { return c; };
      setAmountText(priceEl, formatMoney(shown(variant.price)));

      /* Second montant TTC (pro suisse) : recalcule a chaque configuration, a
         partir du prix HT du variant courant. apply() ne fait rien hors mode
         ht-ttc, et retire alors un TTC perime. */
      if (window.FOG_TTC) {
        window.FOG_TTC.apply(priceEl.parentNode, variant.price, config.currency || 'CHF');
      }

      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = formatMoney(shown(variant.compare_at_price));
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }
    }
  }

  function updateVariantId(variant) {
    var input = document.getElementById('variant-id-input');
    if (input && variant) {
      input.value = variant.id;
    }
  }

  function updateSku(variant) {
    var sku = document.getElementById('product-sku');
    if (!sku) return;

    var value = sku.querySelector('.pc-sku__value');
    var nextSku = variant && variant.sku ? String(variant.sku).trim() : '';
    if (value) value.textContent = nextSku;
    sku.hidden = !nextSku;
  }

  /**
   * Lien « Demander un devis » des produits sur demande (X-GROW BAR) : rendu
   * une fois en Liquid avec la variante initiale (snippets/product-sur-demande),
   * il citait cette reference meme apres un changement d'option. On garde le
   * chemin (prefixe de langue compris) et les autres parametres.
   */
  function updateDevisLink(variant) {
    var devis = page.querySelector('.fog-on-demand__cta');
    if (!devis) return;
    var u = new URL(devis.getAttribute('href'), location.origin);
    var nextSku = variant && variant.sku ? String(variant.sku).trim() : '';
    if (nextSku) u.searchParams.set('reference', nextSku);
    else u.searchParams.delete('reference');
    devis.setAttribute('href', u.pathname + u.search);
  }

  /**
   * Disponibilite du variant courant. Reproduit exactement les etats et les
   * libelles de snippets/product-stock-status.liquid, qui rend l'affichage
   * initial : toute modification doit etre faite des deux cotes.
   */
  function updateStock(variant) {
    var el = document.getElementById('product-stock');
    if (!el) return;

    var text = el.querySelector('[data-fog-stock-text]');
    var threshold = parseInt(el.getAttribute('data-threshold'), 10);
    if (!(threshold > 0)) threshold = 10;

    var state = 'out';
    var label = i18n('products.sold_out');

    if (variant) {
      var qty = typeof variant.inventory_quantity === 'number' ? variant.inventory_quantity : 0;
      if (!variant.inventory_management) {
        if (variant.available) {
          state = 'untracked';
          label = i18n('products.stock.in_stock');
        }
      } else if (qty > 0) {
        state = qty <= threshold ? 'low' : 'in';
        label = i18n(qty === 1 ? 'products.stock.remaining_one' : 'products.stock.remaining_other', { count: qty });
      } else if (variant.inventory_policy === 'continue') {
        state = 'backorder';
        label = i18n('products.stock.backorder');
      }
    }

    el.className = 'fog-stock fog-stock--' + state;
    if (text) text.textContent = label;
  }

  function updateURL(variant) {
    if (variant && window.history && window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }
  }

  function updateAddToCart(variant) {
    var btn = document.getElementById('add-to-cart-btn');
    var text = document.getElementById('atc-text');
    if (!btn || !text) return;

    var isTransient = btn.classList.contains('loading')
      || btn.classList.contains('is-success')
      || btn.classList.contains('is-error');

    if (!variant || !variant.available) {
      btn.classList.add('disabled');
      btn.setAttribute('aria-disabled', 'true');
      if (!isTransient) text.textContent = i18n('products.configurable.sold_out_short');
    } else {
      btn.classList.remove('disabled');
      btn.removeAttribute('aria-disabled');
      if (!isTransient) text.textContent = i18n('products.configurable.add_short');
    }
  }

  function onVariantChange() {
    var variant = findVariant();
    state.currentVariant = variant;
    updatePrice(variant);
    updateVariantId(variant);
    updateSku(variant);
    updateDevisLink(variant);
    updateURL(variant);
    updateAddToCart(variant);
    updateStock(variant);
    if (isB2b) updateB2bPrice(variant);
    updateBars();
    updateMedia(variant);
    updateSpecs(variant);
  }

  // === VARIANT SELECTOR (button-option) ===
  function initVariants() {
    var buttons = page.querySelectorAll('.button-option');
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var group = btn.closest('.option_group');
        if (!group) return;

        // Deactivate all in group
        group.querySelectorAll('.button-option').forEach(function (b) {
          b.classList.remove('active');
          b.setAttribute('aria-checked', 'false');
        });

        // Activate clicked
        btn.classList.add('active');
        btn.setAttribute('aria-checked', 'true');

        onVariantChange();
      });

      // Keyboard support
      btn.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          btn.click();
        }
      });
    });

    // Set initial variant
    state.currentVariant = findVariant();
    if (isB2b) updateB2bPrice(state.currentVariant);
    // Resynchronise la disponibilite : le rendu Liquid porte sur
    // selected_or_first_available_variant, qui n'est pas toujours la combinaison
    // d'options reellement active au chargement.
    updateStock(state.currentVariant);
  }

  // === PERFORMANCE BARS (metafields variant) ===
  function updateBars() {
    var v = state.currentVariant;
    if (!v) return;

    // Bars 1-4 : lecture directe des metafields variant
    for (var i = 1; i <= 4; i++) {
      var fill = document.getElementById('bar-' + i);
      var valEl = document.getElementById('bar-' + i + '-val');
      var raw = v['bar' + i];
      var val = parseInt(raw, 10);
      if (isNaN(val)) val = 0;
      if (fill) fill.style.width = val + '%';
      if (valEl) valEl.textContent = val;
    }

    // Bar 5 : level indicator (PRO / ADVANCED / EXPERT)
    var bar5 = document.getElementById('bar-5');
    var raw5 = v.bar5;
    var val5 = parseInt(raw5, 10);
    if (isNaN(val5)) val5 = 0;
    if (bar5) bar5.style.width = val5 + '%';

    // Tier class on .bar-wrap._2 controls fill color
    var barWrap5 = page.querySelector('.bar-wrap._2');
    if (barWrap5) {
      barWrap5.classList.remove('tier-pro', 'tier-advanced', 'tier-expert');
      if (val5 > 66) barWrap5.classList.add('tier-expert');
      else if (val5 > 33) barWrap5.classList.add('tier-advanced');
      else barWrap5.classList.add('tier-pro');
    }

    // Highlight active label (PRO <= 33, ADVANCED 33-66, EXPERT > 66)
    var labels = page.querySelectorAll('.bar-level-labels .count-text');
    if (labels.length === 3) {
      labels.forEach(function (l) { l.classList.remove('is-active'); });
      var idx = 0;
      if (val5 > 66) idx = 2;
      else if (val5 > 33) idx = 1;
      labels[idx].classList.add('is-active');
    }
  }

  // === MEDIA (video 3D dynamique par variante) ===
  // Deux sources possibles : HEVC alpha (Safari, en premier) puis WebM VP9 alpha.
  // Chaque source est mise a jour selon son data-format ; avant ce correctif seule la
  // premiere <source> l'etait, ce qui aurait ecrit le WebM a la place du HEVC.
  function updateMedia(v) {
    if (!v || !v.video3d) return;
    var video = document.getElementById('product-video');
    if (!video) return;
    var webm = video.querySelector('source[data-format="webm"]') || video.querySelector('source:not([data-format])');
    if (!webm) return;
    var hevc = video.querySelector('source[data-format="hevc"]');
    var hevcUrl = v.video3d_hevc || '';
    // Video encore differee (video-lazy.js n'a pas atteint le viewport) : on met a
    // jour les sources en attente au lieu de forcer le telechargement. Sans ce garde,
    // le lazy reposerait ensuite l'ancienne URL par-dessus le changement de variante.
    var attente = video.hasAttribute('data-lazy-video') && !video.dataset.lazyLoaded;
    var attr = attente ? 'data-src' : 'src';
    var change = false;
    if (webm.getAttribute(attr) !== v.video3d) { webm.setAttribute(attr, v.video3d); change = true; }
    if (hevcUrl) {
      if (!hevc) {
        hevc = document.createElement('source');
        hevc.setAttribute('data-format', 'hevc');
        hevc.setAttribute('type', 'video/mp4; codecs="hvc1"');
        video.insertBefore(hevc, webm);
      }
      if (hevc.getAttribute(attr) !== hevcUrl) { hevc.setAttribute(attr, hevcUrl); change = true; }
    } else if (hevc) {
      hevc.parentNode.removeChild(hevc);
      change = true;
    }
    if (attente || !change) return;
    video.load();
    var p = video.play();
    if (p && p.catch) p.catch(function () {});
  }

  // === SPECS (mise a jour des specs techniques par variante) ===
  function isBogusSpec(s) {
    if (s == null) return true;
    var t = String(s).trim();
    if (t === '' || t === 'Variant MetaField Here') return true;
    if (t.toLowerCase().indexOf('blabla') !== -1) return true;
    return false;
  }

  function updateSpecs(v) {
    if (!v) return;
    var specs = page.querySelectorAll('[data-variant-spec]');
    specs.forEach(function (el) {
      var key = el.getAttribute('data-variant-spec');
      var val = v[key];
      if (val === undefined || val === null) return;
      if (isBogusSpec(val)) return;
      el.textContent = val;
    });
  }

  // === QUANTITY +/- ===
  function initQuantity() {
    var decreaser = page.querySelector('.quantity-decreaser');
    var increaser = page.querySelector('.quantity-increaser');
    var input = document.getElementById('product-quantity');
    var hidden = document.getElementById('quantity-hidden');

    if (decreaser && input) {
      decreaser.addEventListener('click', function () {
        var val = parseInt(input.value, 10) || 1;
        input.value = Math.max(val - 1, 1);
        if (hidden) hidden.value = input.value;
        if (isB2b) updateB2bPrice(state.currentVariant);
      });
    }

    if (increaser && input) {
      increaser.addEventListener('click', function () {
        var val = parseInt(input.value, 10) || 1;
        input.value = Math.min(val + 1, 99);
        if (hidden) hidden.value = input.value;
        if (isB2b) updateB2bPrice(state.currentVariant);
      });
    }

    // Entree dans la quantite : #quantity-form (sans action) se soumettait en
    // GET, remplacait ?variant= par ?quantity=N et rechargeait la page sur la
    // variante par defaut. On valide la saisie a la place.
    var qtyForm = document.getElementById('quantity-form');
    if (qtyForm && input) {
      qtyForm.addEventListener('submit', function (e) {
        e.preventDefault();
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    if (input) {
      input.addEventListener('change', function () {
        var val = parseInt(input.value, 10);
        if (isNaN(val) || val < 1) input.value = 1;
        if (val > 99) input.value = 99;
        if (hidden) hidden.value = input.value;
        if (isB2b) updateB2bPrice(state.currentVariant);
      });
    }
  }

  // === ADD TO CART (AJAX) ===
  function initAddToCart() {
    var btn = document.getElementById('add-to-cart-btn');
    if (!btn) return;

    btn.addEventListener('click', function () {
      if (btn.classList.contains('disabled') || btn.classList.contains('loading')) return;

      var variantInput = document.getElementById('variant-id-input');
      var qtyInput = document.getElementById('product-quantity');
      if (!variantInput || !variantInput.value) return;

      var id = parseInt(variantInput.value, 10);
      var qty = parseInt(qtyInput ? qtyInput.value : '1', 10);
      if (isNaN(qty) || qty < 1) qty = 1;

      // En B2B, le panier passe par SparkLayer (prix/regles pro), pas /cart/add.js.
      if (isB2b) { addToCartB2b(state.currentVariant, qty); return; }
      if (isNaN(id)) return;
      addToCart(id, qty);
    });

    // Keyboard support
    btn.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        btn.click();
      }
    });
  }

  function resetButton() {
    var btn = document.getElementById('add-to-cart-btn');
    var text = document.getElementById('atc-text');
    var spinner = document.getElementById('atc-spinner');
    if (btn) btn.classList.remove('loading', 'is-success', 'is-error');
    if (spinner) spinner.style.display = 'none';
    if (text) {
      text.style.display = '';
      var v = state.currentVariant;
      text.textContent = i18n((v && !v.available) ? 'products.configurable.sold_out_short' : 'products.configurable.add_short');
    }
  }

  function addToCart(variantId, quantity) {
    var btn = document.getElementById('add-to-cart-btn');
    var text = document.getElementById('atc-text');
    var spinner = document.getElementById('atc-spinner');

    if (btn) btn.classList.add('loading');
    if (text) text.style.display = 'none';
    if (spinner) spinner.style.display = 'inline-block';

    fetch(window.FOG_ROUTES.url('cart/add.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Erreur ' + res.status);
        return res.json();
      })
      .then(function () {
        if (spinner) spinner.style.display = 'none';
        if (btn) { btn.classList.remove('loading'); btn.classList.add('is-success'); }
        if (text) { text.textContent = i18n('products.configurable.added_short'); text.style.display = ''; }
        updateCartCount();
        setTimeout(resetButton, 1600);
      })
      .catch(function () {
        if (spinner) spinner.style.display = 'none';
        if (btn) { btn.classList.remove('loading'); btn.classList.add('is-error'); }
        if (text) { text.textContent = i18n('products.configurable.error_short'); text.style.display = ''; }
        showFeedback(i18n('products.configurable.add_error'), 'error');
        setTimeout(resetButton, 1800);
      });
  }

  function showFeedback(message, type) {
    var el = document.getElementById('cart-feedback');
    if (!el) return;
    el.textContent = message;
    el.className = 'pc-cart-feedback pc-cart-feedback--' + type;
    el.style.display = '';
    setTimeout(function () { el.style.display = 'none'; }, 3000);
  }

  function updateCartCount() {
    fetch(window.FOG_ROUTES.url('cart.js'))
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var counters = document.querySelectorAll('[data-cart-count]');
        counters.forEach(function (el) {
          el.textContent = cart.item_count;
        });
        var headerCount = document.querySelector('.header__cart-count, .cart-count, #cart-count');
        if (headerCount) {
          headerCount.textContent = cart.item_count;
          // Le badge est rendu masque quand le panier part de zero : sans ce
          // retrait, le premier ajout restait invisible dans le header.
          if (cart.item_count > 0) headerCount.removeAttribute('hidden');
        }
      })
      .catch(function () {});
  }

  // === INIT ===
  initVariants();
  initQuantity();
  initAddToCart();
  onVariantChange();

  // === X-Grow image slider ===
  const slider = document.querySelector('[data-xgrow-slider]');
  if (slider) {
    const track = slider.querySelector('.xgrow-slider__track');
    const slides = Array.from(slider.querySelectorAll('.xgrow-slider__slide'));
    const nav = slider.querySelector('.xgrow-slider__nav');
    const prev = slider.querySelector('.xgrow-slider__arrow--prev');
    const next = slider.querySelector('.xgrow-slider__arrow--next');

    let current = 0;

    const dots = slides.map((_, i) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('aria-label', i18n('products.gallery.image_dot', { index: i + 1 }));
      if (i === 0) b.setAttribute('aria-current', 'true');
      b.addEventListener('click', () => goTo(i));
      nav.appendChild(b);
      return b;
    });

    function goTo(i) {
      current = (i + slides.length) % slides.length;
      track.scrollTo({ left: slides[current].offsetLeft, behavior: 'smooth' });
      dots.forEach((d, idx) => d.setAttribute('aria-current', idx === current ? 'true' : 'false'));
    }

    prev.addEventListener('click', () => goTo(current - 1));
    next.addEventListener('click', () => goTo(current + 1));

    let scrollDebounce;
    track.addEventListener('scroll', () => {
      clearTimeout(scrollDebounce);
      scrollDebounce = setTimeout(() => {
        const idx = Math.round(track.scrollLeft / track.clientWidth);
        if (idx !== current) {
          current = idx;
          dots.forEach((d, di) => d.setAttribute('aria-current', di === current ? 'true' : 'false'));
        }
      }, 80);
    });
  }

})();
